import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';

interface CreateTransferRequest {
  artifactId: string;
  targetIds: string[];
}

interface CreateTransferResponse {
  operationId: string;
  correlationId: string;
}

export function useCreateTransfer() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CreateTransferRequest) =>
      apiClient.post<CreateTransferResponse>('/transfers', body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.transfers.history });
    },
  });
}
